import { useQuery } from '@tanstack/react-query';
import { billing } from '@repletoryreach/sdk-api';

/**
 * The wallet, on the shared `['wallet']` key.
 *
 * Four pages plus the sidebar each declared this query inline. They already
 * shared the cache entry because the key matched, but nothing enforced that;
 * one typo and the shell would have shown a different balance from the page
 * behind it.
 */
export function useWallet() {
  return useQuery({
    queryKey: ['wallet'],
    queryFn: () => billing.getWallet(),
    // The balance moves as messages send, so the shell should not hold a stale
    // figure for an entire session.
    staleTime: 30_000
  });
}
